/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm , themeV2, coloredScrollBar} from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	nav: {
		width: '100%',
		padding: pxToEm(20),
		minHeight: pxToEm(100),
		flex: '1', // ensure this is the only area that flexes and collapses (logo, user, toggle all remain visible at all times, and nav gets vertical scroll)
		overflow: 'auto',
		'&.sidebarOpen': {
			'&-false': {
				'& .navitem': {
					'& .item': {
						paddingRight: '0',
						'& .text, .indicator': { display: 'none' }
					},
					'& .subitems': { display: 'none' }
				}
			}
		},
    extend: coloredScrollBar(themeV2.color.base.scrollbar)
	}
}; 